module.exports = __webpack_public_path__ + "static/media/garden-vue.bd099d1f.jpg";